import { damAncestorKeys } from '../queries/AlpacaQueries';
import { useQuery } from '@tanstack/react-query';
import AncestryApi from '../apis/ancestry_api';
import { useState } from 'react';
import { useUserDetails } from '../helpers/UserContext';
import DamAncestryDisplay from './DamAncestryDisplay/DamAncestryDisplay';
// import UpdateDamAncestryDisplay from './UpdateDamAncestryDisplay/UpdateDamAncestryDisplay';
import { FaEdit } from 'react-icons/fa';
import UpdateDamAncestryDisplay from './UpdateDamAncestryDisplay/UpdateDamAncestryDisplay';

export default function DamAncestry({ alpacaId }: { alpacaId: number }) {
  const [isEdit, setIsEdit] = useState(false);
  const [userDetails] = useUserDetails();
  const { data: damAncestry = {} } = useQuery({
    queryKey: damAncestorKeys.for(alpacaId),
    queryFn: () => AncestryApi.getDamAncestry(alpacaId),
  });
  return (
    <div className='mb-6 w-full'>
      <div className='mb-2 flex items-center justify-start'>
        <h3 id='dam-ancestry' className='m-0'>
          Dam Ancestry{' '}
        </h3>
        <button
          name='edit'
          className='ml-4 p-1 text-xs font-bold uppercase hover:opacity-70'
          onClick={() => setIsEdit(!isEdit)}
        >
          <div className='flex items-center gap-2'>
            <FaEdit /> Edit
          </div>
        </button>
      </div>
      {isEdit ? (
        <UpdateDamAncestryDisplay
          close={() => setIsEdit(false)}
          damAncestry={
            (Object.keys(damAncestry)?.length ?? 0) > 0
              ? { ...damAncestry }
              : {
                  alpacaId: alpacaId,
                  applicationUserId: userDetails?.userId,
                }
          }
        />
      ) : (
        <DamAncestryDisplay damAncestry={damAncestry} />
      )}
    </div>
  );
}
